// Catálogo gastronómico completo de The Fit Bar
// Diseñado para máxima apetitosidad, datos nutricionales y pedido directo por WhatsApp

export const CATEGORIAS = [
  { id: "todos", nombre: "Todos", emoji: "✨", icono: "bi-grid-fill" },
  { id: "platosfuertes", nombre: "Platos Fuertes", emoji: "🥩", icono: "bi-fire" },
  { id: "hotcakes", nombre: "Hot Cakes Fit", emoji: "🥞", icono: "bi-heart-fill" },
  { id: "sandwiches", nombre: "Sándwiches", emoji: "🥪", icono: "bi-layers-fill" },
  { id: "omelettes", nombre: "Omelettes", emoji: "🍳", icono: "bi-egg-fried" },
  { id: "ensaladas", nombre: "Ensaladas", emoji: "🥗", icono: "bi-flower1" },
  { id: "avena", nombre: "Bowls & Avena", emoji: "🥣", icono: "bi-cup-hot-fill" },
  { id: "bebidas", nombre: "Bebidas & Shakes", emoji: "🥤", icono: "bi-droplet-half" },
];

export const OBJETIVOS = [
  { id: "todos", label: "Todos los Platillos", icon: "bi-stars" },
  { id: "alta_proteina", label: "💪 Alto en Proteína", icon: "bi-lightning-charge" },
  { id: "low_carb", label: "🥑 Low Carb / Definición", icon: "bi-shield-check" },
  { id: "desayuno", label: "🥞 Desayuno & Brunch", icon: "bi-sun-fill" },
  { id: "favoritos", label: "🔥 Los Más Pedidos", icon: "bi-fire" },
];

export const PLATILLOS = [
  // --- PLATOS FUERTES ---
  {
    id: "top-sirloin",
    nombre: "Top Sirloin a la Parrilla",
    categoriaId: "platosfuertes",
    categoriaNombre: "Platos Fuertes",
    foto: require("@/assets/img/galeria/PLATO_FUERTE_TOP_SIRLOIN.png"),
    badgeType: "fire",
    descripcion: "Corte selecto de top sirloin (200g) asado al término ideal, jugoso por dentro y sellado a la parrilla, servido con arroz integral al vapor y ensalada fresca con aguacate.",
    macros: { proteina: "46g", carbos: "28g", grasas: "12g", calorias: "410 kcal" },
    objetivos: ["alta_proteina", "low_carb", "favoritos"],
    destacado: true,
  },
  {
    id: "salmon-finas-hierbas",
    nombre: "Salmón a las Finas Hierbas",
    categoriaId: "platosfuertes",
    categoriaNombre: "Platos Fuertes",
    foto: require("@/assets/img/galeria/PLATO_FUERTE_SALMÓN_A_LAS_FINAS_HIERBAS.png"),
    badgeType: "gourmet",
    descripcion: "Filete de salmón rosado chileno sellado a fuego lento con costra de finas hierbas aromáticas, toque de limón amarillo y guarnición de vegetales salteados crujientes.",
    macros: { proteina: "38g", carbos: "14g", grasas: "16g", calorias: "360 kcal" },
    objetivos: ["alta_proteina", "low_carb", "favoritos"],
    destacado: true,
  },
  {
    id: "pechuga-pollo-grill",
    nombre: "Pechuga de Pollo Marinada",
    categoriaId: "platosfuertes",
    categoriaNombre: "Platos Fuertes",
    foto: require("@/assets/img/galeria/PLATO_FUERTE_PECHUGA_DE_POLLO.png"),
    badgeType: "protein",
    descripcion: "200 gr. de pechuga de pollo marinada con especias naturales y cítricos, asada a la plancha para mantener su máxima jugosidad. Acompañada con camote asado y ensalada mixta.",
    macros: { proteina: "48g", carbos: "26g", grasas: "6g", calorias: "350 kcal" },
    objetivos: ["alta_proteina", "low_carb"],
    destacado: false,
  },
  {
    id: "filete-pescado-hierbas",
    nombre: "Filete de Pescado a la Plancha",
    categoriaId: "platosfuertes",
    categoriaNombre: "Platos Fuertes",
    foto: require("@/assets/img/galeria/PLATO_FUERTE_FILETE_DE_PESCADO.png"),
    badgeType: "fresh",
    descripcion: "Filete blanco tierno sazonado con sal marina, ajo tostado y finas hierbas, cocinado a la plancha con unas gotas de aceite de oliva virgen extra y vegetales al vapor.",
    macros: { proteina: "36g", carbos: "10g", grasas: "5g", calorias: "240 kcal" },
    objetivos: ["alta_proteina", "low_carb"],
    destacado: false,
  },

  // --- HOT CAKES FIT ---
  {
    id: "matcha-fit-cakes",
    nombre: "Matcha Fit Cakes",
    categoriaId: "hotcakes",
    categoriaNombre: "Hot Cakes Saludables",
    foto: require("@/assets/img/galeria/HOTCAKES_MATCHA_FIT_CAKES.png"),
    badgeType: "fresh",
    descripcion: "Tres esponjosos hot cakes elaborados con harina de avena entera, matcha ceremonial japonés orgánico, espinaca baby fresca, decorados con fresas, plátano y miel pura.",
    macros: { proteina: "24g", carbos: "42g", grasas: "6g", calorias: "320 kcal" },
    objetivos: ["desayuno", "favoritos"],
    destacado: true,
  },
  {
    id: "hot-cakes-high-protein",
    nombre: "Hot Cakes High Protein",
    categoriaId: "hotcakes",
    categoriaNombre: "Hot Cakes Saludables",
    foto: require("@/assets/img/galeria/HOT_CAKES_HIGH_PROTEIN.png"),
    badgeType: "protein",
    descripcion: "Torre de tres hot cakes dorados enriquecidos con proteína aislada de suero de leche (Whey Isolate), avena integral y un toque aromático de canela de Ceilán.",
    macros: { proteina: "36g", carbos: "38g", grasas: "5g", calorias: "340 kcal" },
    objetivos: ["alta_proteina", "desayuno", "favoritos"],
    destacado: true,
  },
  {
    id: "hot-cakes-fit-clasicos",
    nombre: "Hot Cakes Fit Clásicos",
    categoriaId: "hotcakes",
    categoriaNombre: "Hot Cakes Saludables",
    foto: require("@/assets/img/galeria/HOTCAKES_HOT_CAKES_FIT.png"),
    badgeType: "favorite",
    descripcion: "Tres suaves hot cakes de avena recién horneados, aromatizados con canela y vainilla natural, servidos con rodajas de fruta fresca de temporada y miel de agave.",
    macros: { proteina: "20g", carbos: "40g", grasas: "5g", calorias: "280 kcal" },
    objetivos: ["desayuno"],
    destacado: false,
  },
  {
    id: "chocolate-fit-cakes",
    nombre: "Chocolate Fit Cakes",
    categoriaId: "hotcakes",
    categoriaNombre: "Hot Cakes Saludables",
    foto: require("@/assets/img/galeria/HOTCAKES_CHOCOLATE_FIT_CAKES.png"),
    badgeType: "gourmet",
    descripcion: "El antojo dulce sin culpa: 3 hot cakes preparados con cacao oscuro 100% puro, avena molida, nibs de cacao crujientes y fresas recién fileteadas.",
    macros: { proteina: "22g", carbos: "44g", grasas: "7g", calorias: "330 kcal" },
    objetivos: ["desayuno", "favoritos"],
    destacado: false,
  },

  // --- SÁNDWICHES ---
  {
    id: "sandwich-mass-pechuga",
    nombre: "Sándwich Mass Pechuga",
    categoriaId: "sandwiches",
    categoriaNombre: "Sándwiches Integrales",
    foto: require("@/assets/img/galeria/SANDWICH_MASS_PECHUGA.png"),
    badgeType: "fire",
    descripcion: "150 gr. de pechuga de pollo tierna a la plancha, lechuga romana crocante, jitomate bola, pepino fresco, germinado de alfalfa y nuestro aderezo manzano artesanal.",
    macros: { proteina: "38g", carbos: "32g", grasas: "7g", calorias: "340 kcal" },
    objetivos: ["alta_proteina", "favoritos"],
    destacado: true,
  },
  {
    id: "sandwich-tunni",
    nombre: "Sándwich Tunni",
    categoriaId: "sandwiches",
    categoriaNombre: "Sándwiches Integrales",
    foto: require("@/assets/img/galeria/SANDWICH_TUNNI.png"),
    badgeType: "fresh",
    descripcion: "150 gr. de ensalada de atún blanco con aderezo ligero de mostaza y mayonesa baja en grasa, jitomate, pepino, lechuga y un toque de salsa de manzano casera.",
    macros: { proteina: "34g", carbos: "30g", grasas: "8g", calorias: "330 kcal" },
    objetivos: ["alta_proteina"],
    destacado: false,
  },
  {
    id: "sandwich-verde",
    nombre: "Sándwich Verde Supremo",
    categoriaId: "sandwiches",
    categoriaNombre: "Sándwiches Integrales",
    foto: require("@/assets/img/galeria/SÁNDWICH_VERDE.png"),
    badgeType: "fresh",
    descripcion: "Generosa cama de aguacate hass cremoso en pan artesanal multicereal, germinado de alfalfa crujiente, pepino persa, lechuga fresca y reducción de chile manzano.",
    macros: { proteina: "16g", carbos: "34g", grasas: "14g", calorias: "320 kcal" },
    objetivos: ["low_carb", "favoritos"],
    destacado: false,
  },

  // --- BOWLS & AVENA ---
  {
    id: "avena-imperial",
    nombre: "Avena Imperial con Frutos Rojos",
    categoriaId: "avena",
    categoriaNombre: "Bowls & Avenas",
    foto: require("@/assets/img/galeria/AVENA_IMPERIAL.png"),
    badgeType: "gourmet",
    descripcion: "Avena cremosa cocida lentamente con leche de almendras y canela, coronada artísticamente con fresas del bosque, arándanos, plátano, almendras tostadas y miel orgánica.",
    macros: { proteina: "15g", carbos: "54g", grasas: "8g", calorias: "350 kcal" },
    objetivos: ["desayuno", "favoritos"],
    destacado: true,
  },

  // --- OMELETTES ---
  {
    id: "omelette-champinones-queso",
    nombre: "Omelette de Champiñones con Queso",
    categoriaId: "omelettes",
    categoriaNombre: "Omelettes Proteicos",
    foto: require("@/assets/img/galeria/OMELETTE_DE_CHAMPIÑONES_CON_QUESO.png"),
    badgeType: "favorite",
    descripcion: "Omelette preparado con 3 claras y 1 huevo entero, relleno de champiñones salteados al ajillo y queso panela asado derretido. Acompañado de frijolitos de la olla y ensalada.",
    macros: { proteina: "28g", carbos: "8g", grasas: "11g", calorias: "250 kcal" },
    objetivos: ["alta_proteina", "low_carb", "desayuno"],
    destacado: true,
  },
  {
    id: "omelette-nopales-salsa-verde",
    nombre: "Omelette con Nopales y Salsa Verde",
    categoriaId: "omelettes",
    categoriaNombre: "Omelettes Proteicos",
    foto: require("@/assets/img/galeria/OMELETTE_CON_NOPALES_Y_SALSA_VERDE.png"),
    badgeType: "fresh",
    descripcion: "Omelette ligero bañado en salsa verde tatemada casera, relleno de tiernos nopales asados y queso panela bajo en sodio. Alto en fibra y digestión ligera.",
    macros: { proteina: "26g", carbos: "9g", grasas: "9g", calorias: "230 kcal" },
    objetivos: ["alta_proteina", "low_carb", "desayuno"],
    destacado: false,
  },
  {
    id: "omelette-veggie",
    nombre: "Omelette Veggie del Huerto",
    categoriaId: "omelettes",
    categoriaNombre: "Omelettes Proteicos",
    foto: require("@/assets/img/galeria/OMELETTE_VEGGIE.png"),
    badgeType: "fresh",
    descripcion: "Relleno abundante de pimientos tricolores salteados, calabacitas tiernas, espinaca baby y cebolla morada caramelizada. Sabor limpio y revitalizante.",
    macros: { proteina: "24g", carbos: "7g", grasas: "8g", calorias: "210 kcal" },
    objetivos: ["low_carb", "desayuno"],
    destacado: false,
  },
  {
    id: "omelette-verde",
    nombre: "Omelette Verde Detox",
    categoriaId: "omelettes",
    categoriaNombre: "Omelettes Proteicos",
    foto: require("@/assets/img/galeria/OMELETTE_VERDE.png"),
    badgeType: "fresh",
    descripcion: "Claras de huevo batidas con puré de espinaca y hierbas finas, relleno de aguacate y queso fresco de cabra suave. Acompañado de tostadas horneadas.",
    macros: { proteina: "27g", carbos: "6g", grasas: "10g", calorias: "220 kcal" },
    objetivos: ["alta_proteina", "low_carb", "desayuno"],
    destacado: false,
  },

  // --- ENSALADAS ---
  {
    id: "ensalada-fresona",
    nombre: "Ensalada Fresona Gourmet",
    categoriaId: "ensaladas",
    categoriaNombre: "Ensaladas Frescas",
    foto: require("@/assets/img/galeria/ENSALADA_FRESONA.png"),
    badgeType: "favorite",
    descripcion: "Mix selecto de lechugas hidropónicas, fresas dulces fileteadas, queso feta cremoso, nueces garapiñadas en miel de agave y vinagreta balsámica de frutos rojos.",
    macros: { proteina: "14g", carbos: "28g", grasas: "12g", calorias: "280 kcal" },
    objetivos: ["low_carb", "favoritos"],
    destacado: true,
  },
  {
    id: "ensalada-ancestral",
    nombre: "Ensalada Ancestral",
    categoriaId: "ensaladas",
    categoriaNombre: "Ensaladas Frescas",
    foto: require("@/assets/img/galeria/ENSALADA_ANCESTRAL.png"),
    badgeType: "fresh",
    descripcion: "Mezcla energética de quinoa perlada, semillas de chía, pepino, cubos de jitomate cherry, aguacate en abanico y aderezo cítrico de cilantro y limón.",
    macros: { proteina: "16g", carbos: "32g", grasas: "11g", calorias: "290 kcal" },
    objetivos: ["low_carb"],
    destacado: false,
  },
  {
    id: "ensalada-cancun",
    nombre: "Ensalada Cancún Tropical",
    categoriaId: "ensaladas",
    categoriaNombre: "Ensaladas Frescas",
    foto: require("@/assets/img/galeria/ENSALADA_CANCÚN.png"),
    badgeType: "gourmet",
    descripcion: "Frescura caribeña con tiras de pollo asado, piña asada al grill, pepino, pimientos rojos y aderezo cremoso de maracuyá y yogur griego artesanal.",
    macros: { proteina: "32g", carbos: "24g", grasas: "7g", calorias: "290 kcal" },
    objetivos: ["alta_proteina", "favoritos"],
    destacado: false,
  },

  // --- BEBIDAS & SHAKES ---
  {
    id: "batido-proteina",
    nombre: "Batido de Proteína Post-Workout",
    categoriaId: "bebidas",
    categoriaNombre: "Bebidas & Shakes",
    foto: require("@/assets/img/galeria/BEBIDA_BATIDO_DE_PROTEÍNA.png"),
    badgeType: "protein",
    descripcion: "El shake recuperador definitivo: Proteína Whey Isolate sabor vainilla o chocolate, plátano, crema de cacahuate 100% natural y leche vegetal de almendras.",
    macros: { proteina: "32g", carbos: "26g", grasas: "6g", calorias: "290 kcal" },
    objetivos: ["alta_proteina", "favoritos"],
    destacado: true,
  },
  {
    id: "jugo-verde-detox",
    nombre: "Jugo Verde Power Detox",
    categoriaId: "bebidas",
    categoriaNombre: "Bebidas & Shakes",
    foto: require("@/assets/img/galeria/BEBIDA_JUGO_VERDE.png"),
    badgeType: "fresh",
    descripcion: "Extractor en frío con espinaca, pepino, apio, manzana verde, jengibre fresco y limón. Sin agua añadida, pura vitalidad y enzimas vivas.",
    macros: { proteina: "4g", carbos: "22g", grasas: "1g", calorias: "110 kcal" },
    objetivos: ["low_carb", "favoritos"],
    destacado: true,
  },
  {
    id: "te-chai-latte",
    nombre: "Té Chai Latte Fit",
    categoriaId: "bebidas",
    categoriaNombre: "Bebidas & Shakes",
    foto: require("@/assets/img/galeria/BEBIDA_TÉ_CHAI_LATTE.png"),
    badgeType: "gourmet",
    descripcion: "Infusión aromática de canela, cardamomo, clavo y jengibre espumada con leche de avena o almendras caliente, endulzada ligeramente con monk fruit.",
    macros: { proteina: "5g", carbos: "14g", grasas: "3g", calorias: "100 kcal" },
    objetivos: ["desayuno"],
    destacado: false,
  },
  {
    id: "agua-frutas-natural",
    nombre: "Agua de Frutas Natural (1 Litro)",
    categoriaId: "bebidas",
    categoriaNombre: "Bebidas & Shakes",
    foto: require("@/assets/img/galeria/BEBIDA_AGUA_DE_FRUTAS_1_LT.png"),
    badgeType: "fresh",
    descripcion: "Preparada al momento con fruta fresca de la temporada (sandía, melón, piña o jamaica sin azúcar), servida en vaso de 1 litro súper fría para rehidratarte.",
    macros: { proteina: "1g", carbos: "18g", grasas: "0g", calorias: "80 kcal" },
    objetivos: ["desayuno"],
    destacado: false,
  },
  {
    id: "naranjada-limonada-natural",
    nombre: "Naranjada / Limonada Mineral",
    categoriaId: "bebidas",
    categoriaNombre: "Bebidas & Shakes",
    foto: require("@/assets/img/galeria/BEBIDA_NARANJADA.png"),
    badgeType: "fresh",
    descripcion: "Cítricos recién exprimidos con agua mineral de manantial y hielo frappé. Puedes pedirla natural o endulzada con stevia o miel de agave.",
    macros: { proteina: "1g", carbos: "12g", grasas: "0g", calorias: "50 kcal" },
    objetivos: [],
    destacado: false,
  },
];

export function getPlatilloWhatsappUrl(platillo) {
  const tel = "529983641651";
  const texto = `¡Hola The Fit Bar! 🍽️ Se me antojó pedir el platillo *${platillo.nombre}* (${platillo.categoriaNombre}). ¿Me podrían tomar mi pedido por favor?`;
  return `https://wa.me/${tel}?text=${encodeURIComponent(texto)}`;
}

export function getGeneralWhatsappUrl() {
  const tel = "529983641651";
  const texto = "¡Hola The Fit Bar! 🍽️ Me gustaría consultar el menú y hacer un pedido por WhatsApp.";
  return `https://wa.me/${tel}?text=${encodeURIComponent(texto)}`;
}
